import { Icon } from '@/design-system/icons/Icon';
import { Kbd } from '@/components/atoms/Kbd';

type Props = { onOpen: () => void; placeholder?: string };

export const SearchPill = ({ onOpen, placeholder = 'Buscar associações, strains, pessoas…' }: Props) => (
  <button className="search-pill" type="button" onClick={onOpen}>
    <Icon name="search" size={16} className="ic" />
    <span>{placeholder}</span>
    <Kbd>⌘K</Kbd>
  </button>
);
